module.exports = __webpack_public_path__ + "images/giftTree/graduation.faac96b2131a51edde50284b0688a147.png";